import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Logo5k } from "../Styles/Icons";
import { FailurePop, SuccessPop } from "../Popup";

const DeleteAccount = () => {
  //useState
  const [mobileNumber, setMobileNumber] = useState("");
  const [OTP, setOTP] = useState("");
  const [openOTP, setOpenOTP] = useState("");
  const [disableNumber, setDisableNumber] = useState(false);
  const [disableOTP, setDisableOTP] = useState(true);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);

  //Functions
  const handleMobile = async (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    if (onlyNums.length < 11) {
      setMobileNumber(onlyNums);
    }
  };

  function handleChange(e) {
    setOTP(e.target.value);
    if (e.target.value.length === 4) {
      verifyOTP(e.target.value);
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      sendOTP();
    }
  };

  //APIs

  const sendOTP = async () => {
    if (mobileNumber.length !== 10) {
      setContent("Please Provide 10 Digit Mobile Number");
      setModalFail(true);
      return true;
    }
    try {
      const response = await global.$axios.post("/customer/accountOtp", {
        mobile: mobileNumber,
      });
      if (response.data.status == "success") {
        setOpenOTP(true);
        setDisableNumber(true);
        setContent("OTP Sent Successfully");
        setModalSuccess(true);
      } else {
        console.log("Something Went Wrong", response.data.message);
        setContent(response.data.message);
        setModalFail(true);
      }
    } catch (error) {
      console.log("Something Went Wrong", error);
    }
  };

  const verifyOTP = async (e) => {
    if (e.length !== 4) {
      setContent("Please Provide 4 Digit OTP");
      setModalFail(true);
      return true;
    }
    console.log("verified");

    try {
      const response = await global.$axios.post("customer/verifyAccountOtp", {
        mobile: mobileNumber,
        otp: e,
      });
      console.log("verify response", response.data);
      if (response.data.status == "success") {
        setDisableOTP(false);
        console.log("success");
        setContent("OTP Verified");
        setModalSuccess(true);
      } else {
        setContent(response.data.message);
        setModalFail(true);
        setDisableOTP(true);
        console.log("Something Went Wrong", response.data.message);
      }
    } catch (error) {
      setDisableOTP(true);

      console.log("Verify OTP Issue", error);
    }
  };

  const removeAccount = async () => {
    try {
      const response = await global.$axios.post("customer/deleteCustomer", {
        mobile: mobileNumber,
      });
      if (response.data.status == "success") {
        setContent("Account Deleted Successfully");
        setModalSuccess(true);
        setTimeout(() => {
          setModalSuccess(false);
          window.location.reload();
        }, 2000);
      } else {
        setContent(response.data.message);
        setModalFail(true);
      }
    } catch (error) {
      console.log("Delete Account Issue", error);
    }
  };

  return (
    <Grid sx={{ p: 4 }}>
      <Grid>
        <Logo5k />
      </Grid>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // mt: 10,
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          style={{ display: "flex", flexDirection: "column", gap: 30 }}
        >
          <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
            Close Your 5K Car Care Account
          </Typography>
          <Typography style={{ fontSize: "18px", fontWeight: 500 }}>
            Please read this carefully
          </Typography>
          <Typography
            style={{ fontSize: "16px", fontWeight: 500, lineHeight: 2 }}
          >
            <li>
              You are about to submit a request for us to permanently close your
              5K Car Care account and delete your data. Once your account is
              closed all of the products and services accessed through your
              account will no longer be available to you, across any sites
              globally.
            </li>
          </Typography>
          <Typography
            style={{ fontSize: "16px", fontWeight: 500, lineHeight: 2 }}
          >
            <li>
              Please note account closure is a permanent action and once your
              account is closed it will no longer be available to and cannot be
              restored. If you decide later that you want to start ordering from
              us again or if you would like to use products and services that
              requires an account, you will need to create anew account.
            </li>
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 5,
        }}
      >
        <Grid
          item
          md={5}
          xs={10}
          sx={{ display: "flex", flexDirection: "column", gap: 4 }}
        >
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 2, md: 0 },
            }}
          >
            <TextField
              value={mobileNumber}
              onChange={(e) => handleMobile(e)}
              autoFocus
              label="Mobile Number"
              onKeyDown={handleKeyDown}
              size="small"
              fullWidth
              sx={{
                borderRadius: 1,
                mt: 0.5,
                width: { xs: "80%", md: "70%" },
              }}
            />
            <Button
              sx={{ textTransform: "capitalize" }}
              variant="contained"
              size="medium"
              onClick={sendOTP}
              disabled={disableNumber}
            >
              Get OTP
            </Button>
          </Grid>

          {openOTP && (
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 2, md: 0 },
              }}
            >
              <TextField
                value={OTP}
                onChange={(e) => handleChange(e)}
                autoFocus
                label="OTP"
                size="small"
                fullWidth
                sx={{
                  borderRadius: 1,
                  mt: 0.5,
                  width: "70%",
                }}
                inputProps={{ maxLength: 4 }}
              />
              <Button
                sx={{ textTransform: "capitalize" }}
                variant="contained"
                size="medium"
                disabled={disableOTP}
                onClick={removeAccount}
              >
                Delete Account
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}

      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
    </Grid>
  );
};

export default DeleteAccount;
